/**
 * Production API Testing Utility
 * Run this in browser console to debug API connectivity
 */

export async function testProductionAPI() {
  const testUrl = 'http://103.69.193.159/BigDataAPI/api/TRReportDaily/NangSuatWood?fromDate=2025-07-31&toDate=2025-07-31&compID=3';
  
  console.log('🧪 Testing Production API Connectivity...');
  console.log('🔗 Target URL:', testUrl);

  // Test 1: JSONProxy
  try {
    console.log('\n1️⃣ Testing JSONProxy...');
    const jsonProxyUrl = `https://jsonp.afeld.me/?url=${encodeURIComponent(testUrl)}`;
    console.log('📡 Proxy URL:', jsonProxyUrl);
    
    const response = await fetch(jsonProxyUrl);
    console.log('📊 Response status:', response.status);
    
    if (response.ok) {
      const data = await response.json();
      console.log('✅ JSONProxy SUCCESS!');
      console.log('📈 Data type:', typeof data);
      console.log('📊 Data length:', Array.isArray(data) ? data.length : 'Not array');
      console.log('🔍 Sample data:', Array.isArray(data) && data[0] ? data[0] : data);
      return { proxy: 'JSONProxy', success: true, data };
    }
  } catch (error) {
    console.error('❌ JSONProxy failed:', error);
  }

  // Test 2: CORS.SH
  try {
    console.log('\n2️⃣ Testing CORS.SH...');
    const corsShUrl = `https://cors.sh/${testUrl}`;
    console.log('📡 Proxy URL:', corsShUrl);
    
    const response = await fetch(corsShUrl, {
      headers: {
        'x-cors-api-key': 'temp_key_demo',
      }
    });
    console.log('📊 Response status:', response.status);
    
    if (response.ok) {
      const data = await response.json();
      console.log('✅ CORS.SH SUCCESS!');
      console.log('📈 Data type:', typeof data);
      console.log('📊 Data length:', Array.isArray(data) ? data.length : 'Not array');
      console.log('🔍 Sample data:', Array.isArray(data) && data[0] ? data[0] : data);
      return { proxy: 'CORS.SH', success: true, data };
    }
  } catch (error) {
    console.error('❌ CORS.SH failed:', error);
  }

  // Test 3: ThingProxy
  try {
    console.log('\n3️⃣ Testing ThingProxy...');
    const thingProxyUrl = `https://thingproxy.freeboard.io/fetch/${testUrl}`;
    console.log('📡 Proxy URL:', thingProxyUrl);
    
    const response = await fetch(thingProxyUrl);
    console.log('📊 Response status:', response.status);
    
    if (response.ok) {
      const data = await response.json();
      console.log('✅ ThingProxy SUCCESS!');
      console.log('📈 Data type:', typeof data);
      console.log('📊 Data length:', Array.isArray(data) ? data.length : 'Not array');
      console.log('🔍 Sample data:', Array.isArray(data) && data[0] ? data[0] : data);
      return { proxy: 'ThingProxy', success: true, data };
    }
  } catch (error) {
    console.error('❌ ThingProxy failed:', error);
  }

  // Test 4: AllOrigins
  try {
    console.log('\n4️⃣ Testing AllOrigins...');
    const allOriginsUrl = `https://api.allorigins.win/get?url=${encodeURIComponent(testUrl)}`;
    console.log('📡 Proxy URL:', allOriginsUrl);
    
    const response = await fetch(allOriginsUrl);
    console.log('📊 Response status:', response.status);
    
    if (response.ok) {
      const proxyResult = await response.json();
      console.log('📦 Proxy result:', proxyResult);
      
      if (proxyResult.contents) {
        try {
          const data = JSON.parse(proxyResult.contents);
          console.log('✅ AllOrigins SUCCESS!');
          console.log('📈 Data type:', typeof data);
          console.log('📊 Data length:', Array.isArray(data) ? data.length : 'Not array');
          console.log('🔍 Sample data:', Array.isArray(data) && data[0] ? data[0] : data);
          return { proxy: 'AllOrigins', success: true, data };
        } catch (parseError) {
          console.error('❌ AllOrigins parse failed:', parseError);
          console.log('🔍 Raw contents:', proxyResult.contents.substring(0, 200) + '...');
        }
      }
    }
  } catch (error) {
    console.error('❌ AllOrigins failed:', error);
  }

  console.log('\n❌ All proxies failed!');
  return { proxy: 'none', success: false, data: null };
}

// Test function that can be called from console
export async function quickTest() {
  console.log('🚀 Quick Production API Test Starting...');
  const result = await testProductionAPI();
  
  if (result.success) {
    console.log(`\n🎉 SUCCESS with ${result.proxy}!`);
    console.log('📊 Ready to use production feature!');
  } else {
    console.log('\n😞 All tests failed. Using mock data.');
  }
  
  return result;
}

// Auto-attach to window for easy console access
if (typeof window !== 'undefined') {
  (window as any).testProductionAPI = testProductionAPI;
  (window as any).quickTest = quickTest;
  console.log('🔧 API testing functions attached to window:');
  console.log('   - window.testProductionAPI()');
  console.log('   - window.quickTest()');
}